const DsmRadius = {
  None: "var(--radius-none)",
  Xs: "var(--radius-xs)",
  S: "var(--radius-s)",
  M: "var(--radius-m)",
  Full: "var(--radius-full)"
};

export { DsmRadius };
